import { StarFilled } from "@faire/web/slate/icons/foundation/StarFilled";
import { Row } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import React from "react";

interface IProps {
  rating?: string;
}

export const MaybeBrandReviewTile: React.FC<IProps> = (props: IProps) => {
  const { rating } = props;

  if (!rating) {
    return null;
  }

  return (
    <Row align="center" data-test-id="brand-review-tile">
      <StarFilled fontSize="12px" />
      <Spacer width={2} />
      <Typography>{rating}</Typography>
      <Spacer width="1x" />
    </Row>
  );
};
